import { Flow } from "../types";
import { SCREENS } from "../screens";
import { shouldCollectGDPRAgreements } from "@/utils/contract";
import { Contract } from "@/types/contract";
import { isCustomerIdentified, ocrSeen } from "../helpers";

export const S1_SELF_SERVICE: Flow = {
  [SCREENS.WELCOME]: {
    next: (contract: Contract) => {
      if (ocrSeen(contract) && isCustomerIdentified(contract)) {
        return SCREENS.CUSTOMER;
      }
      if (!ocrSeen(contract) && isCustomerIdentified(contract)) {
        return SCREENS.OCR;
      }
      return SCREENS.IDENTIFICATION;
    },
    back: () => null,
  },
  [SCREENS.IDENTIFICATION]: {
    next: (contract: Contract) => {
      if (ocrSeen(contract)) {
        return SCREENS.CUSTOMER;
      }
      return SCREENS.OCR;
    },
    back: () => SCREENS.WELCOME,
  },
  [SCREENS.OCR]: {
    next: () => SCREENS.CUSTOMER,
    back: (contract: Contract) => (isCustomerIdentified(contract) ? SCREENS.IDENTIFICATION : SCREENS.WELCOME),
  },

  [SCREENS.CUSTOMER]: {
    next: () => SCREENS.SUPPLY_POINT,
    back: (contract: Contract) => {
      if (!ocrSeen(contract)) {
        return SCREENS.OCR;
      }
      return SCREENS.IDENTIFICATION;
    },
  },
  [SCREENS.SUPPLY_POINT]: {
    next: () => SCREENS.SUPPLIER,
    back: () => SCREENS.CUSTOMER,
  },
  [SCREENS.SUPPLIER]: {
    next: () => SCREENS.PAYMENTS,
    back: () => SCREENS.SUPPLY_POINT,
  },
  [SCREENS.PAYMENTS]: {
    next: () => SCREENS.RECAPITULATION,
    back: () => SCREENS.SUPPLIER,
  },
  [SCREENS.RECAPITULATION]: {
    next: (contract: Contract, options?: { gdprAgreed?: boolean; isContractRequest?: boolean }) =>
      !options?.gdprAgreed && shouldCollectGDPRAgreements(contract, options?.isContractRequest ?? false)
        ? SCREENS.AGREEMENTS
        : SCREENS.VIEW,
    back: () => SCREENS.PAYMENTS,
  },
  [SCREENS.AGREEMENTS]: {
    next: () => SCREENS.VIEW,
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.VIEW]: {
    next: () => SCREENS.SIGNATURE,
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.SIGNATURE]: {
    next: () => SCREENS.SMS_CODE,
    back: () => SCREENS.VIEW,
  },
  [SCREENS.SIGNATURE_ON_PHONE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => null,
  },
  [SCREENS.SMS_CODE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => SCREENS.SIGNATURE,
  },
  [SCREENS.THANK_YOU]: {
    next: () => null,
    back: () => null,
  },
};
